/* Native details work without JS. Delegation also supports Theme Editor reloads. */
document.documentElement.classList.replace('no-js', 'js');

document.addEventListener('keydown', (event) => {
  if (event.key !== 'Escape') return;
  const openDetails = event.target.closest('details[open]');
  if (!openDetails) return;
  openDetails.open = false;
  openDetails.querySelector(':scope > summary')?.focus();
});

document.addEventListener('click', (event) => {
  document.querySelectorAll('.site-header details[open]').forEach((details) => {
    if (!details.contains(event.target)) details.open = false;
  });
});

document.addEventListener('focusin', (event) => {
  document.querySelectorAll('.site-header details[open]').forEach((details) => {
    if (!details.contains(event.target)) details.open = false;
  });
});

window.addEventListener('pageshow', (event) => {
  // Refresh Shopify-rendered cart counts after browser back/forward cache restores.
  if (event.persisted) window.location.reload();
});
